// 연락처
export const formatPhoneNumber = (value) => {
  value = value.replace(/[^0-9]/g, "");
  return value.replace(
    /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
    "$1-$2-$3"
  );
};
// 생년월일
export const formatBirthDate = (value) => {
  // 숫자 이외의 문자는 제거
  value = value.replace(/[^0-9]/g, "");

  // YYYY.MM.DD 형식으로 포맷팅
  if (value.length <= 4) {
    return value;
  } else if (value.length <= 6) {
    return `${value.slice(0, 4)}.${value.slice(4)}`;
  } else {
    return `${value.slice(0, 4)}.${value.slice(4, 6)}.${value.slice(6, 8)}`;
  }
};

// Date 객체 날짜변환 (ex . xxxx년.xx월.xx일)
export const formatDate = (data) => {
  const date = new Date(data);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}.${month}.${day} ${hours}시 ${minutes}분`;
};

export const typeList = (typeKey) => {
  const typeListData = {
    total : "전체",
    distributor : "총판",
    branch : "지점",
    store : "가맹점",
    rider : "기사"
  }
  return typeListData[typeKey];
}

